module.exports = __webpack_public_path__ + "assets/3ab23fb8b7274967cbaa37c0c138bb0b.png";